export enum Roles {
    AGENCY = 'Agency',
    CLIENT = 'Client'
}
export enum BillTypeEnum {
    AUTO_INSURANCE = "auto_insurance",
    AUTO_PAYMENT = "auto_payment",
    RENT = "rent_mortgage",
    UTILITY_BILL = "utility",
    OTHER_BILLS = "other"
}
export enum QuoteFrequency {
    MONTHLY = 1,
    QUARTERLY = 3,
    HALF_YEARLY = 6,
    ANNUAL = 12
}
export enum CustomerPayFrequency {
    WEEKLY = 'weekly',
    BI_WEEKLY = 'biweekly',
    MONTHLY = 'monthly',
    SPECIFIC_DAYS = 'specific_days'
}
export enum PaymentType {
    CASH = 'cash',
    CARD = 'card',
    DIRECT_DEBIT = 'directDebit'
}
